// Предупреждение о совпадении: такой кандидат, возможно, уже в воронке.
//
// Это ПРЕДУПРЕЖДЕНИЕ, а не отказ, и текст обязан звучать именно так. Телефон оставляют не все,
// а полные тёзки у заказчика встречаются: запрет по совпадению телефона заблокировал бы
// заведение настоящего второго человека, а молчание завело бы третью карточку одному и тому же.
// Поэтому — назвать, ПО ЧЕМУ совпало, и дать ссылку на найденную карточку. Решает человек.
//
// Два признака совпадения приходят с сервера отдельно и означают разное: `phone` — точное
// совпадение нормализованного номера, `fuzzy` — похожие ФИО. Слипание их в «найден дубль»
// стоило бы человеку разбирательства: по телефону он склеит не глядя, по ФИО обязан
// посмотреть обе карточки.

import { RiAlertLine } from '@remixicon/react';
import { Link } from 'react-router';

import * as Alert from '@/shared/ui/alert';

import type { CandidateDuplicateReport } from '../api/candidates';
import { CANDIDATE_STATUS_TITLES } from '../dictionaries';
import { hiringHref } from '../route';

const ПО_ЧЕМУ: Readonly<Record<'phone' | 'fuzzy', string>> = {
  phone: 'совпал телефон',
  fuzzy: 'похожи фамилия и имя',
};

export function DuplicateNotice({
  report,
  note,
}: {
  report: CandidateDuplicateReport;
  /**
   * Что делать дальше, словами под совпадениями. У мастера и у карточки это разные вещи: в
   * мастере человек ещё может передумать, в карточке она уже создана.
   */
  note: string;
}) {
  const совпадения = report.hits ?? [];
  if (!report.found || совпадения.length === 0) {
    return null;
  }
  return (
    <Alert.Root variant='light' status='warning' size='small' role='status'>
      <Alert.Icon as={RiAlertLine} />
      <div className='flex min-w-0 flex-col gap-1'>
        <span>
          {совпадения.length === 1
            ? 'Похоже, такой кандидат уже в воронке'
            : `Похожих карточек найдено: ${совпадения.length}`}
        </span>
        <ul className='flex flex-col gap-0.5'>
          {совпадения.map((совпадение) => (
            <li key={совпадение.candidate_id}>
              <Link
                to={hiringHref('candidates', { filters: {}, panels: [] }, совпадение.candidate_id)}
                className='text-primary-base underline тач:inline-flex тач:min-h-11 тач:items-center'
              >
                {совпадение.display_name}
              </Link>
              <span className='text-paragraph-xs opacity-80'>
                {' '}
                — {ПО_ЧЕМУ[совпадение.matched_by]}, сейчас «
                {CANDIDATE_STATUS_TITLES[совпадение.status]}»
              </span>
            </li>
          ))}
        </ul>
        <span className='text-paragraph-xs opacity-80'>{note}</span>
      </div>
    </Alert.Root>
  );
}
